import type { AppSettings } from './AppSettingsContext.types';

export const migrations = [
  (settings: AppSettings) => ({
    ...settings,
  }),
];

export const currentVersion = migrations.length;
